import React from 'react'
import { useTypedTranslation } from 'src/shared/i18next/hooks/use-typed-translation'
import type { LocoAssetsKeysType } from 'src/shared/i18next/types/loco-assets-keys-type'
import FieldErrorUi from './ui/FieldErrorUi'

interface FieldErrorsProps {
  errors?: string[]
  fontFamily?: string
}

export const FieldErrors: React.FC<FieldErrorsProps> = ({
  errors = [],
  fontFamily,
  ...rest
}) => {
  const { t, i18n } = useTypedTranslation()

  return errors?.map(error => {
    const translated = error
      .split('\n')
      .map(line =>
        i18n.exists(line as LocoAssetsKeysType)
          ? t(line as LocoAssetsKeysType)
          : line,
      )
      .join('\n')

    const style =
      fontFamily != null
        ? { ...(rest as { style?: React.CSSProperties }).style, fontFamily }
        : (rest as { style?: React.CSSProperties }).style

    return (
      <FieldErrorUi {...rest} style={style}>
        {translated}
      </FieldErrorUi>
    )
  })
}
